import { createApi } from '@reduxjs/toolkit/query/react';

import { AllDataResponseDto, StatusDto, UserMin } from '../common/dto/common.dto';
import { ArchiveExceptionStatusDto, ExceptionStatusChangeCreateDto } from '../common/dto/exception-reports.dto';
import customFetchBase from './base.service';

const API_URI = import.meta.env.VITE_DATA_COLLECTION_SERVICE;
const TAG_TYPE = 'ExceptionReport';
const TAG_TYPE_SINGLE = 'ExceptionReport-Single';

export const exceptionReportUpdateApi = createApi({
  reducerPath: 'exceptionReportUpdateApi',
  baseQuery: customFetchBase(`${API_URI}/api/exception-report`),
  tagTypes: [TAG_TYPE, TAG_TYPE_SINGLE],
  endpoints: (builder) => ({
    updateExceptionStatus: builder.mutation<StatusDto, Partial<ExceptionStatusChangeCreateDto>>({
      query(data) {
        return {
          url: `update-exception-status`,
          method: 'PUT',
          body: data,
        };
      },
      invalidatesTags: [TAG_TYPE_SINGLE],
    }),
    archiveException: builder.mutation<StatusDto, Partial<ArchiveExceptionStatusDto>>({
      query(data) {
        return {
          url: `archive-exceptions`,
          method: 'PUT',
          body: data,
        };
      },
      invalidatesTags: [TAG_TYPE_SINGLE],
    }),
    getAssignedUserForExceptionReport: builder.mutation<AllDataResponseDto<UserMin>, Partial<string>>({
      query(locationId) {
        return {
          url: 'get-assigned-users',
          method: 'PATCH',
          body: { locationId },
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
  }),
});

// auto-generated based on the defined endpoints
export const { useUpdateExceptionStatusMutation, useArchiveExceptionMutation, useGetAssignedUserForExceptionReportMutation } = exceptionReportUpdateApi;
